<template>
  <div class="people-tabs">
      <div class="people-tabs-header">
        <!-- <p class="people-tabs-header-left"
          :class="{ 'people-tabs-header-active': activeTab === 0}"
          @click="setActiveTab(0)">
          Applicants
        </p> -->
        <p class="people-tabs-header-left"
          :class="{ 'people-tabs-header-active': activeTab === 1}"
          @click="setActiveTab(1)">
          Students
        </p>
        <p class="people-tabs-header-right"
          :class="{ 'people-tabs-header-active': activeTab === 2}"
          @click="setActiveTab(2)">
          Businesses
        </p>
      </div>

      <template v-for="(group, i) in people">
        <div class="people-tabs-benefits" :key="i" v-if="activeTab === i">
          <div class="people-tabs-benefit"
            v-for="({ pic, name, desc }, ind) in group"
              :key="ind">

              <div class="people-tabs-face">
                <img :src="require(`@/assets/images/${pic}`)" />
              </div>

              <div class="people-tabs-text">
                <h4>{{ name }}</h4>
                <p>{{ desc }}</p>
              </div>
          </div>
        </div>
      </template>
  </div>
</template>

<script>
import peopleData from '@/data/people.json'
export default {
  data: () => ({
    activeTab: 1,
    people: peopleData
  }),
  methods: {
    setActiveTab (id) {
      this.activeTab = id
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .people-tabs {
    text-align: center;
    min-height: 240px;

    &-header {
      text-align: center;
      display: grid;
      grid-template-columns: 1fr 1fr;
      font-size: 12px;

      p {
        border-top: 3px solid var(--primary-green);
        border-bottom: 3px solid var(--primary-green);
        padding: 10px 7px;
        cursor: pointer;
        transition: all .2s ease-in-out;
        font-family: 'ProximaNova-Bold';

        &:hover {
          background-color: var(--primary-green-hover);
          color: var(--primary-white);
        }
      }

      &-left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        border-left: 3px solid var(--primary-green);
        border-right: 3px solid var(--primary-green);
      }

      &-active {
        background-color: var(--primary-green);
        color: var(--primary-white);

        &:hover {
          background-color: var(--primary-green)!important;
        }
      }

      &-right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        border-left: 3px solid var(--primary-green);
        border-right: 3px solid var(--primary-green);
      }

      @media #{$mobile} {
        p {
          font-size: 3vw;
        }
      }
    }

    &-benefits {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 30px;
      align-items: start;
      margin-top: 10px;

      .img {
        width: 68px;
        height: 68px;
        margin: 0 auto;
        background-color: var(--img-grey);
        border-radius: 100%;
      }
    }

    &-benefit {
      display: grid;
      grid-template-columns: auto 1fr;
      text-align: left;
      grid-column-gap: 20px;
      align-items: start;
      margin-bottom: 40px;

      h4 {
        margin: 8px 0 2px 0;
        white-space: nowrap;
        font-family: 'ProximaNova-Bold';
      }

      p {
        margin: 0;
        font-size: 16px;
        line-height: 24px;
      }

      img {
        width: 80px;
        height: 80px;
      }
    }

    @media #{$desktop} {
      margin: 0 auto;
      max-width: 900px;

      &-header {
        font-size: 18px;
        grid-template-columns: 1fr 1fr;
      }

      &-benefits {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 20px;
        align-items: start;
        font-size: 16px;
        margin-top: 20px;

        .img {
          width: 68px;
          height: 68px;
          margin: 0 auto;
          background-color: var(--img-grey);
          border-radius: 100%;
        }
      }

      &-benefit {
        display: grid;
        grid-template-columns: auto 1fr;
        text-align: left;
        grid-column-gap: 20px;
        align-items: start;
        margin-bottom: 40px;

        h4 {
          font-size: 22px;
          margin: 8px 0 2px 0;
          white-space: nowrap;
        }

        p {
          margin: 0;
          font-size: 15px;
          line-height: 22px;
        }

        img {
          width: 80px;
          height: 80px;
        }
      }
    }

    @media #{$lxs} {
      &-benefits {
        grid-template-columns: 1fr 1fr;
      }
      &-benefit {
        margin-bottom: 30px;
      }
      &-face {
        margin-bottom: 10px;
      }
    }
    @media #{$sxs} {
      &-benefits {
        grid-template-columns: 1fr;
      }
      &-benefit {
        margin-bottom: 10px;
      }
    }
  }
</style>
